const isMacLikePlatform = () => {
  if (typeof navigator === 'undefined') {
    return false;
  }

  const userAgent = navigator.userAgent || '';
  return /Macintosh|Mac OS X|iPhone|iPad|iPod/i.test(userAgent);
};

const downloadBlob = (blob, fileName) => {
  const blobUrl = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = blobUrl;
  anchor.download = fileName;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  setTimeout(() => URL.revokeObjectURL(blobUrl), 1000);
};

const openWhatsAppUrl = (url) => {
  const openedWindow = window.open(url, '_blank', 'noopener,noreferrer');
  return Boolean(openedWindow);
};

const copyTextToClipboard = async (text) => {
  if (
    typeof navigator === 'undefined'
    || !navigator.clipboard
    || typeof navigator.clipboard.writeText !== 'function'
  ) {
    return false;
  }

  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch (error) {
    return false;
  }
};

export const shareBlobToWhatsApp = async ({ blob, fileName, title, text }) => {
  if (!blob) {
    throw new Error('Paylasilacak gorsel olusturulamadi');
  }

  const file = new File([blob], fileName, { type: blob.type || 'image/png' });
  const hasNativeShare = (
    typeof navigator !== 'undefined'
    && typeof navigator.share === 'function'
    && typeof navigator.canShare === 'function'
    && navigator.canShare({ files: [file] })
  );

  if (hasNativeShare) {
    await navigator.share({
      files: [file],
      title,
      text
    });
    return { method: 'native-share' };
  }

  downloadBlob(blob, fileName);
  window.open('https://web.whatsapp.com/', '_blank', 'noopener,noreferrer');

  return {
    method: 'download-and-web',
    isMacLike: isMacLikePlatform()
  };
};

export const shareTextToWhatsApp = async ({ text, title = 'Paylasim' }) => {
  const normalizedText = String(text || '').trim();
  if (!normalizedText) {
    throw new Error('Paylasilacak mesaj bulunamadi');
  }

  const hasNativeShare = (
    typeof navigator !== 'undefined'
    && typeof navigator.share === 'function'
  );

  if (hasNativeShare) {
    try {
      await navigator.share({
        title,
        text: normalizedText
      });
      return { method: 'native-share' };
    } catch (error) {
      if (error?.name !== 'AbortError') {
        // Native share desteklenmesine ragmen hata olursa alt fallback'e gec.
      } else {
        throw error;
      }
    }
  }

  const encodedText = encodeURIComponent(normalizedText);
  const primaryUrl = isMacLikePlatform()
    ? `https://web.whatsapp.com/send?text=${encodedText}`
    : `https://wa.me/?text=${encodedText}`;

  if (openWhatsAppUrl(primaryUrl)) {
    return {
      method: 'web-open',
      isMacLike: isMacLikePlatform()
    };
  }

  const copied = await copyTextToClipboard(normalizedText);
  return {
    method: copied ? 'clipboard-fallback' : 'manual-fallback',
    isMacLike: isMacLikePlatform()
  };
};
